import { type FC, type PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react';

import { FatalErrorPage } from '#apps/client-web/pages/fatal-error';

export type AppErrorBoundaryProps = PropsWithChildren;

export const AppErrorBoundary: FC<AppErrorBoundaryProps> = ({ children }) => (
  <ErrorBoundary
    FallbackComponent={FatalErrorPage}
    onError={(err, info) => captureException(err, { extra: { info } })}>
    {children}
  </ErrorBoundary>
);
